import mongoose from "mongoose";
import { match } from "@mssi/pssp-shared";

export interface Accessory {
  _id: mongoose.Schema.Types.ObjectId;
  endCustomerAccountId: string; // use for ITSM Customer ID
  resellerAccountId?: string;
  opportunityId?: string;
  globalOpportunityId?: string;
  fleetId?: string;
  accessoryId: string;
  productNumber: string;
  productName?: string;
  serialNumber: string;
  description?: string;
  installDate?: Date;
  associatedDeviceId?: string;
  providerContractId?: string;
  endCustomerCostCenterId?: string;
  endCustomerCostCenterName?: string;
  resellerCostCenterId?: string;
  resellerCostCenterName?: string;
  costCenterId?: string;
  costCenterName?: string;
  refreshId?: string;
}

export const AccessorySchema = new mongoose.Schema<Accessory>({
  endCustomerAccountId: { type: String, index: true, sparse: true },
  resellerAccountId: { type: String, index: true, sparse: true },
  opportunityId: { type: String, index: true, sparse: true },
  globalOpportunityId: { type: String, index: true, sparse: true },
  fleetId: String,
  accessoryId: { type: String, index: true, unique: true },
  productNumber: String,
  productName: String,
  serialNumber: String,
  description: String,
  installDate: Date,
  associatedDeviceId: String,
  providerContractId: String,
  endCustomerCostCenterId: String,
  resellerCostCenterId: String,
  endCustomerCostCenterName: String,
  resellerCostCenterName: String,
  costCenterId: String,
  costCenterName: String,
  refreshId: String,
});

AccessorySchema.index({ endCustomerAccountId: 1, refreshId: 1 });
AccessorySchema.index({ endCustomerAccountId: 1, accessoryId: 1 });
AccessorySchema.index({ endCustomerAccountId: 1, serialNumber: 1 });

export const props: (keyof Accessory)[] = [
  "endCustomerAccountId",
  "resellerAccountId",
  "opportunityId",
  "globalOpportunityId",
  "fleetId",
  "accessoryId",
  "productNumber",
  "productName",
  "serialNumber",
  "description",
  "installDate",
  "associatedDeviceId",
  "providerContractId",
  "endCustomerCostCenterId",
  "endCustomerCostCenterName",
  "resellerCostCenterId",
  "resellerCostCenterName",
  "costCenterId",
  "costCenterName",
];

export const searchProps: (keyof Accessory)[] = [
  "accessoryId",
  "opportunityId",
  "globalOpportunityId",
  "productNumber",
  "productName",
  "serialNumber",
  "description",
  "associatedDeviceId",
  "endCustomerCostCenterName",
  "resellerCostCenterName",
  "costCenterName",
];

export function matches(a: Accessory, b: Accessory): boolean {
  return match(a, b, props);
}

export const accessoryUtils = {
  props,
  searchProps,
  matches,
};
